/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { Container, Grid } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import {ReactComponent as editIcon } from "../../../../../../assets/icons/pencil-alt.svg";
import { SvgIcon } from "@material-ui/core";
import { AppAPIService } from "../../../../../../services/AppAPIService";

import { Table, TableBody, TableHead, TableRow } from "@material-ui/core";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";

import { IconButton } from "@material-ui/core";
import { Col, Form } from "react-bootstrap";
import { RiDeleteBin6Line, RiSearchLine } from "react-icons/ri";
import { ConfirmModal } from "./components/ConfirmModal";
import debounce from "lodash.debounce";
import styles from "./styles.module.scss";
import { Pagination } from "@mui/material";

export const ProcessualListing = (props) => {
  let api = AppAPIService.getInstance();
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [confirmedDelete, setConfirmedDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [lastPage, setLastPage] = useState(0)

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const tableHeaders = ["Ações", "Ação", "Data de Modificação"];

  const [actionList, setActionList] = useState();
  const [filterTextAction, setFilterTextAction] = useState("");

  const handleGetListOfAction = useCallback(
    async (page, rowsPerPage) => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          method: "GET",
          url: "/action/list-paginated",
          params: {
            page: page || 1,
            limit: rowsPerPage || 1000,
            search: filterTextAction,
          },
        });
        const { data } = response;

        setActionList(data);
        setLastPage(response?.meta?.lastPage)
      } catch (e) {
        console.error(e);
        Swal.fire("Erro!", "Erro ao buscar Ação.", "error");
      }
      setLoading(false);
    },
    [api, filterTextAction]
  );

  useEffect(() => {
    handleGetListOfAction(page, itemsPerPage);
  }, [handleGetListOfAction, page, itemsPerPage]);

  const handleFilterListAction = useCallback(debounce(setFilterTextAction, 500), []);

  const [idToDelete, setIdToDelete] = useState(null);

  const handleConfirmDelete = useCallback(async (id) => {
    try {
      setLoading(true);
      const result = await api.makeHttpRequest({
        method: "DELETE",
        url: `/action/${id}`,
      });

      if (result?.HttpStatus == 404) {
        Swal.fire(
          "Erro!",
          "Erro ao deletar parametrização de classe processual, categoria não encontrada.",
          "error"
        );
        return;
      }
      if (result?.HttpStatus !== 200) {
        Swal.fire(
          "Erro!",
          "Erro ao deletar parametrização de classe processual.",
          "error"
        );
        return;
      }

      setLoading(false);
      Swal.fire(
        "Sucesso!",
        "Parametrização de classe processual deletada com sucesso.",
        "success"
      ).then(() => {
        history.push("/admin/parametrizacao");
      });
    } catch (e) {
      Swal.fire(
        "Erro!",
        "Erro ao deletar parametrização de classe processual.",
        "error"
      );
    }
    setConfirmedDelete(false);
    setLoading(false);
  }, [api, history]);

  const handleDeleteRecord = (id) => {
    setIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  useEffect(() => {
    if (confirmedDelete) {
      handleConfirmDelete(idToDelete);
    }
  }, [confirmedDelete, handleConfirmDelete, idToDelete]);

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        margin: 0,
      }}
      maxWidth="xl"
    >
      <ConfirmModal
        open={showConfirmDeleteModal}
        handleOpen={setShowConfirmDeleteModal}
        handleConfirm={handleConfirmDelete}
        setConfirmedDelete={setConfirmedDelete}
        id={idToDelete}
        setId={setIdToDelete}
      />
      <Grid
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        container
        style={{
          padding: 0,
        }}
      >
        <Grid
          xs={12}
          style={{
            marginTop: "10px",
          }}
        >
          <Form.Group
            as={Col}
            xs="12"
            className={
              "rmv-all-props row-group-margin-bottom row-grop-margin-bottom-mobile icon-search"
            }
            style={{
              marginTop: "0",
              paddingRight: "0px !important",
            }}
          >
            <button type="button" style={{ paddingLeft: 0 }}>
              <RiSearchLine size={20} />
            </button>
            <Form.Control
              type="text"
              name="search"
              autoComplete="off"
              style={{
                paddingLeft: "60px",
                border: `1px solid ${globalColors.textColor2}70`,
              }}
              className={styles.searchInput}
              onChange={(e) => handleFilterListAction(e.target.value)}
              onFocus={(e) =>
                (e.target.style.border = `.5px solid ${globalColors.primaryColor1}`)
              }
              onBlur={(e) =>
                (e.target.style.border = `.5px solid ${globalColors.textColor2}70`)
              }
              size="lg"
              placeholder="Busque pelo nome da classe processual"
            />
          </Form.Group>
        </Grid>
        <Container
          maxWidth="xl"
          style={{
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: 0,
            marginTop: "16px",
            textAlign: "left",
          }}
        >
          <Table
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px",
              borderCollapse: "collapse",
              borderSpacing: "0px",
              width: "100%",
            }}
            className="table"
          >
            <TableHead>
              <TableRow
                style={{
                textAlign: "left",
                backgroundColor: globalColors.secondaryColor3,
              }}
              >
                {tableHeaders.map((header, index) => (
                  <StyledTableCell
                    key={index}
                    style={{
                      textAlign:
                        header === "Ações" || header === "Data de Modificação"
                          ? "center"
                          : "left",
                          backgroundColor: globalColors.secondaryColor3,
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              style={{
                textAlign: "left",
              }}
            >
              {actionList?.map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell
                    style={{
                      width: "100px",
                      textAlign: "center",
                      padding: 0,
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        props.setEditingRecord(row);
                      }}
                      style={{
                        padding: "5px",
                      }}
                    >
                      <SvgIcon
                        component={editIcon}
                        style={{
                          width: "20px",
                          fill: "transparent",
                          color: globalColors.textColor2
                      }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        handleDeleteRecord(row.id);
                      }}
                      style={{
                        padding: "5px",
                      }}
                    >
                      <RiDeleteBin6Line size={20} />
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      textAlign: "left",
                    }}
                  >
                    {row.action}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {new Date(row.updatedAt)
                      .toLocaleString("pt-BR", { dateStyle: "short" })
                      .replace(",", " - ")}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{
            display: "flex",
            justifyContent: "flex-end"
          }}>
            <Pagination count={lastPage} page={page} onChange={handlePageChange} />
          </div>
        </Container>
      </Grid>
    </Container>
  );
};
